
import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import LoadingButton from '@mui/lab/LoadingButton';
import summaryService from "../../../../services/summary";
import CustomizedSnackbars from "../../../../component/Snackbar/Index";
import { PROFILE } from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";

export default function ModelField(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [btnDiasable, setBtnDiasable] = useState(false);
  const [openSnackbarTitle, setOpenSnackbarTitle] = useState("");
  const [profileDetails, setProfileDetails] = useState({});

  const [initialValues, setInitialValues] = useState({
    Name: "",
    LastName: "",
    Email: "",
  });
  const handleUserGet=async ()=>{
    try {
      const response = await summaryService.getUserDetails();
      if (response.ok) {
        dispatch({ type: PROFILE, profile: response?.data });
        let data={
          Name: response?.data?.fname,
          LastName: response?.data?.lname,
          Email:response?.data?.email,
        }
        setInitialValues(data)
        setProfileDetails(response?.data)
      } 
    } catch (error) {
      console.log(error);
    
    }
  }
  const handleFormSubmit = async (value) => {
   
    setBtnDiasable(true);
    let data={
      firstName:value.Name,
      lastName:value.LastName,
    }
    try {
      const response = await summaryService.updateUser(data);
      if (response.ok) {
        // dispatch({ type: PROFILE, profile: response?.data?.profile });
        handleUserGet()
        setBtnDiasable(false);
        setOpenSnackbar(true);
        setOpenSnackbarTitle("You are updated successfully");     
        props.close()
      } else {
        if (Object.keys(response?.data).length > 0) {
          setBtnDiasable(false);
          setOpenSnackbar(true);
          setOpenSnackbarTitle(response?.data?.message);
        } else {
          setBtnDiasable(false);
          setOpenSnackbar(true);
          setOpenSnackbarTitle("Some thing went wrong");
        }
      }
    } catch (error) {
      console.log(error);
      setOpenSnackbar(true);
    }
  };



  useEffect(() => {
    handleUserGet()
  }, []);

  
  return (
    <div>
      {
        Object.keys(profileDetails).length>0? <Formik
        enableReinitialize
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            Name: Yup.string().required("Required"),             
            Email: Yup.string().required("Required"),
            LastName: Yup.string().required("Required"),
            
          })}
          onSubmit={(values) => {
            handleFormSubmit(values)
            
          }}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            onSubmit,
          }) => (
            <Form>
              <Grid
                container
                //   direction={"column"}
                //   alignItems="center"
                spacing={2}
                //   className={classes.scroll}
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    value={values.Name}
                    name="Name"
                    id="outlined-basic"
                    label="First Name*"
                    variant="outlined"
                    type="text"
                    error={Boolean(touched.Name && errors.Name)}
                    // value={values.projectName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-describedby="outlined-weight-helper-text"
                    // inputProps={{ "aria-label": "projectName" }}
                  />

                  {errors.Name && touched.Name ? (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  ) : null}
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    value={values.LastName}
                    name="LastName"
                    id="outlined-basic"
                    label="Last Name*"
                    variant="outlined"
                    type="text"
                   
                    // value={values.projectName}
                    onBlur={handleBlur}
                    onChange={handleChange}                        
                          // value={values.projectName}
                          error={Boolean(touched.LastName && errors.LastName)}                    
                          helperText={touched.LastName && errors.LastName}
                    aria-describedby="outlined-weight-helper-text"
                    // inputProps={{ "aria-label": "projectName" }}
                  />

                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    value={values.Email}
                    name="Email"
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    type="Email"
                    error={Boolean(touched.Email && errors.Email)}
                    // value={values.projectName}
                    disabled
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-describedby="outlined-weight-helper-text"
                    // inputProps={{ "aria-label": "projectName" }}
                  />

                  {errors.Email && touched.Email ? (
                    <div style={{ color: "red" }}>{errors.Email}</div>
                  ) : null}
                </Grid>
              </Grid>

              <Box
                mt={4}
                sx={{ display: "flex", justifyContent: "space-around" }}
              >
                {/* <Grid item xs={6}>
                  <Button
                   variant="contained"
                    className={classes.cancelButton}
                    //   sx={{ textAlign: "start" }}
                  >
                    cancel
                  </Button>
                </Grid> */}
                <Grid item xs={6} sx={{textAlign:"end"}}>
                <LoadingButton loading={btnDiasable}   loadingIndicator="Loading…" variant="contained" type="submit">
                      Submit
</LoadingButton>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>:<Typography variant="h4">Loading...</Typography>
      }
         
         
   
      <CustomizedSnackbars
        open={openSnackbar}
        close={() => setOpenSnackbar(false)}
        title={openSnackbarTitle}
      />
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  // subcard: {
  //     borderRadius: '4px ! important',
  //     boxShadow: '0 2px 14px 0 rgb(32 40 45 / 8%)'
  // },

//   saveButton: {
//     backgroundColor: "#0F205F",
//     border: "1px solid #F0F0F7",
//     color: "#F0F0F7",
//     textAlign: "end",
//     "&:hover": {
//       backgroundColor: "#0F205F",
//       border: "1px solid #F0F0F7",
//       color: "#F0F0F7",
//     },
//   },
//   cancelButton: {
//     backgroundColor: "#0F205F",
//     border: "1px solid #F0F0F7",
//       color: "#F0F0F7",
//       "&:hover": {
//         backgroundColor: "#0F205F",
//         border: "1px solid #F0F0F7",
//         color: "#F0F0F7",
//       },
//   },
  // submitButton: {
  //     '&:hover': {
  //         backgroundColor: '#0F205F'
  //     }
  // }
}));
